import { getCookie, setExpiringCookie } from '@/utils/cookies';
type AbTestGroup = 'control' | 'variant';

interface AbTestConfig {
  readonly name: string;
  readonly groups: readonly AbTestGroup[];
  readonly featureEnabledForGroup: AbTestGroup;
  readonly isActive: boolean;
  readonly daysActive?: number;
}

const valueShowCaseTestName = 'ab_booking_valueshowcase_group';
const variantTestGroup = 'variant';
const controlTestGroup = 'control';

export const abTestConfigs: AbTestConfig[] = [
  {
    // Control sees no value showcase, variant sees value showcase
    name: valueShowCaseTestName,
    groups: [controlTestGroup, variantTestGroup],
    featureEnabledForGroup: variantTestGroup,
    isActive: false,
    daysActive: 0
  }
];

export function getOrAssignTestGroup(config: AbTestConfig): AbTestGroup {
  const newGroup: AbTestGroup = Math.random() < 0.5 ? 'control' : 'variant';

  try {
    const storageKey = config.name;
    const daysToKeepCookie = config.daysActive;
    const storedGroup = getCookie(storageKey);

    if (storedGroup === 'control' || storedGroup === 'variant') {
      return storedGroup;
    }

    // Set the cookie
    setExpiringCookie(storageKey, newGroup, daysToKeepCookie);

    return newGroup;
  } catch {
    return newGroup;
  }
}

export function getAbTestGroup(testName: string): AbTestGroup | null {
  const config = abTestConfigs.find(configuration => configuration.name === testName);

  if (config?.isActive !== true) {
    return null;
  }

  return getOrAssignTestGroup(config);
}

export function isFeatureEnabledForGroup(testName: string, group: AbTestGroup): boolean {
  const config = abTestConfigs.find(configuration => configuration.name === testName);

  if (config?.isActive !== true) {
    return false;
  }

  const userGroup = getAbTestGroup(testName);

  return userGroup === group;
}

export function isValueShowcaseEnabled(): boolean {
  return isFeatureEnabledForGroup(valueShowCaseTestName, variantTestGroup);
}
